import PropTypes from 'prop-types';
import { CUTTING_STATE } from 'store/video/cutting/reducers';
import VideoCard from 'components/core/VideoCard';
import VideoCardProgress from 'components/core/VideoCard/VideoCardProgress';
import { useLiveArchiveExpirationQuery } from 'services/admin-bff-sdk';
import { MdWarning } from 'react-icons/md';
import css from './ClipCard.module.scss';

function ClipCard({ provider, id, transcoding, liveArchiveTranscoding, originAssetId, className = '' }) {
    const { state: transcodingState, progress: transcodingProgress = 0 } = transcoding || {};

    const { state: liveArchiveTranscodingState, progress: liveArchiveTranscodingProgress = 0 } =
        liveArchiveTranscoding || {};

    const { data: liveArchiveExpiration } = useLiveArchiveExpirationQuery(
        { provider, assetId: originAssetId },
        { skip: !originAssetId }
    );

    const cardState = liveArchiveExpiration?.liveArchiveExpiration ? liveArchiveTranscodingState : transcodingState;

    const cardProgress = liveArchiveExpiration?.liveArchiveExpiration
        ? liveArchiveTranscodingProgress
        : transcodingProgress;

    const progressElement = <VideoCardProgress progress={cardProgress} variant={cardState} />;

    const getCustomType = () => {
        if (cardState === CUTTING_STATE.TRANSCODE) {
            const progressValue = Number(cardProgress).toFixed(0);
            return cardProgress > 0 ? `CLIP CREATION ${progressValue}%` : 'CLIP CREATION SCHEDULED';
        }

        if (cardState === CUTTING_STATE.ERROR) {
            return (
                <span className={css.errorType}>
                    <MdWarning className={css.warningIcon} /> CLIP CREATION FAILED
                </span>
            );
        }

        return null;
    };

    return (
        <VideoCard
            readOnly
            className={className}
            progressElement={progressElement}
            variant="simple"
            provider={provider}
            id={id}
            customType={getCustomType()}
        />
    );
}

ClipCard.propTypes = {
    provider: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    transcoding: PropTypes.object.isRequired,
    className: PropTypes.string,
};

export default ClipCard;
